_         = require 'lodash'
Rx        = require 'ub_wrapped/rx'
ubBanzai  = require 'ub/control/banzai-features'

banz           = ubBanzai.features
isDebugMode    = banz.isDebugModeEnabled
republishingOn = banz.isRepublishingEnabled
showRxUI       = banz.isShowRxUIEventsEnabled

info = if isDebugMode() then console.info.bind console, 'PageSaveObserver:' else _.noop

class PageSaveObserver
  constructor: (@observers) ->
    return unless republishingOn()
    info 'constructor', this

    @changePauser = new Rx.Subject()
    @observers.changeObs.pausable(@changePauser).subscribe(@unsaved)
    @resumeChangeObs()

    @state = new Rx.Subject()
    @state.ub_subscribe info if showRxUI()

  pauseChangeObs:  -> @changePauser.onNext false
  resumeChangeObs: -> @changePauser.onNext true

  emit: (type) => @state.onNext type: "page#{type}"

  saveCompleted: =>
    @emit 'SaveCompleted'
    @resumeChangeObs()

  saveFailed: =>
    @emit 'SaveFailed'
    @resumeChangeObs()

  unsaved: =>
    @emit 'Unsaved'
    @pauseChangeObs()

  saving: =>
    @emit 'Saving'
    @pauseChangeObs()

module.exports = PageSaveObserver



// WEBPACK FOOTER //
// ./src/lp/editor/page-save-observer.coffee